// extracted by mini-css-extract-plugin
var _1 = "DeleteAccountButtons-module__buttonsContainer___EZIQD";
export { _1 as "buttonsContainer" }
